import { useEffect } from 'react';
export const useCommandsToKeysBinding = _ref => {
  let {
    editorRef,
    monacoInstance,
    onEditorDidMount,
    onRunCode,
    onSubmitSolution,
    onTakeHintOrSolution
  } = _ref;
  useEffect(() => {
    var _editorRef$current;
    const editor = (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.editor;
    if (editor == null || monacoInstance == null) {
      return;
    }
    const isMac = navigator.userAgent.indexOf('Macintosh') >= 0;
    const submitSolutionKeys =
    // eslint-disable-next-line no-bitwise
    monacoInstance.KeyMod.CtrlCmd | monacoInstance.KeyMod.Shift | monacoInstance.KeyCode.Enter;
    const runCodeKeys =
    // eslint-disable-next-line no-bitwise
    monacoInstance.KeyMod.CtrlCmd | monacoInstance.KeyCode.Enter;
    const takeHintOrSolutionKeys =
    // eslint-disable-next-line no-bitwise
    monacoInstance.KeyMod.CtrlCmd | monacoInstance.KeyCode.KEY_H;
    editor.addCommand(submitSolutionKeys, onSubmitSolution);
    editor.addCommand(runCodeKeys, onRunCode);
    editor.addCommand(takeHintOrSolutionKeys, onTakeHintOrSolution);
    if (isMac) {
      editor.addCommand(
      // eslint-disable-next-line no-bitwise
      monacoInstance.KeyMod.WinCtrl | monacoInstance.KeyMod.Shift | monacoInstance.KeyCode.Enter, onSubmitSolution);
      editor.addCommand(
      // eslint-disable-next-line no-bitwise
      monacoInstance.KeyMod.WinCtrl | monacoInstance.KeyCode.Enter, onRunCode);
      editor.addCommand(
      // eslint-disable-next-line no-bitwise
      monacoInstance.KeyMod.WinCtrl | monacoInstance.KeyCode.KEY_H, onTakeHintOrSolution);
    }
    onEditorDidMount === null || onEditorDidMount === void 0 || onEditorDidMount(editor, monacoInstance);
  }, [editorRef, monacoInstance, onEditorDidMount, onRunCode, onSubmitSolution, onTakeHintOrSolution]);
};